import React, { Fragment, memo } from 'react';
import { reduxForm } from 'redux-form';
import { submitListener } from '@widergy/web-utils/lib/form';
import { bool, string, func, oneOfType } from 'prop-types';
import { UTLabel, UTLoading } from '@widergy/energy-ui';

import { clientNumberField } from 'constants/fields';
import { message } from 'utils/stringUtils';
import { PENDING_WARRANTY_DEPOSIT_QUERY } from 'constants/reduxForms';
import UTForm from 'app/components/UTForm';

import styles from './styles.module.scss';

const handleKeyDown = handleSubmit => event => submitListener(event, handleSubmit);

const FieldDepositWarranty = ({ pendingWarrantyAmountStatus, handleSubmit, loading }) => (
  <Fragment>
    <UTLoading loading={loading} className={styles.loading}>
      {!pendingWarrantyAmountStatus ? (
        <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} className={styles.form}>
          <UTLabel className={styles.textDescription} textInput black>
            {message('SocialRate:formTitle')}
          </UTLabel>
          <div className={styles.field}>
            <UTForm fields={[clientNumberField]} withoutOrder />
          </div>
        </form>
      ) : (
        <UTLabel className={styles.textDescription} textInput black>
          {pendingWarrantyAmountStatus}
        </UTLabel>
      )}
    </UTLoading>
  </Fragment>
);

FieldDepositWarranty.propTypes = {
  handleSubmit: func,
  pendingWarrantyAmountStatus: oneOfType([bool, string]),
  loading: bool
};

export default reduxForm({ form: PENDING_WARRANTY_DEPOSIT_QUERY })(memo(FieldDepositWarranty));
